module.exports = __webpack_public_path__ + "img/gov.03892da7.png";